import React from 'react';
import { Heart, Users, Globe, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function About() {
  const scrollToGroups = () => {
    const element = document.getElementById('small-groups');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="about" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-gray-50 to-white" />
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-blue-100/40 to-cyan-100/40 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-blue-100/40 to-cyan-100/40 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm font-semibold text-blue-600 uppercase tracking-wide">About Us</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Who We Are
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-cyan-600 mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Evangelize the World Christian Ministry (ETWC) is a full Gospel ministry based in Cleveland, Ohio dedicated to bringing souls to the kingdom through evangelism worldwide.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 md:w-32 md:h-32 bg-primary-600/10 rounded-full -z-10 animate-pulse"></div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 md:w-32 md:h-32 bg-primary-600/10 rounded-full -z-10 animate-pulse delay-300"></div>
            
            <div className="space-y-6">
              <div className="grid sm:grid-cols-2 gap-6">
                <Link
                  to="/statement-of-faith"
                  className="group bg-gradient-card p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-md">
                    <Heart className="text-white" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Our Mission</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    To share the profound message of the Gospel of Jesus Christ with the greatest impact possible.
                  </p>
                  <div className="flex items-center text-primary-600 font-medium group-hover:translate-x-2 transition-transform">
                    <span>Learn More</span>
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </div>
                </Link>

                <a
                  href="https://www.youtube.com/@clevelandstreetpreachers"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-gradient-card p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
                >
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-md">
                    <Globe className="text-white" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Global Impact</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Our YouTube channel has garnered over 32 million views, leading countless individuals to salvation.
                  </p>
                  <div className="flex items-center text-primary-600 font-medium group-hover:translate-x-2 transition-transform">
                    <span>Watch Videos</span>
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </div>
                </a>
              </div>

              <button
                onClick={scrollToGroups}
                className="group bg-gradient-card p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 block w-full text-left border border-gray-100"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform shadow-md">
                  <Users className="text-white" size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Our Vision</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  We are dedicated to planting churches, conducting crusades, and equipping the Body of Christ throughout Latin America, working alongside missionary partners worldwide to reach millions of souls.
                </p>
                <div className="flex items-center text-primary-600 font-medium group-hover:translate-x-2 transition-transform">
                  <span>Join Our Mission</span>
                  <ArrowRight className="ml-2 h-4 w-4" />
                </div>
              </button>
            </div>
          </div>

          <div className="space-y-8">
            <div className="relative group">
              <div className="absolute inset-0 bg-primary-600 rounded-2xl -rotate-6 scale-105 opacity-10 group-hover:rotate-0 group-hover:scale-105 transition-transform duration-300"></div>
              <img
                src="https://hcamiahiytrjczzsrodb.supabase.co/storage/v1/object/public/etwcministry//ETWC%20Ministry%20Photo%201.avif"
                alt="ETWC Ministry Team"
                className="relative w-full aspect-[4/3] object-cover rounded-2xl shadow-xl transition-all duration-300 group-hover:scale-[1.02] group-hover:shadow-2xl"
              />
            </div>

            <div className="relative group">
              <div className="absolute inset-0 bg-primary-600 rounded-2xl rotate-6 scale-105 opacity-10 group-hover:rotate-0 group-hover:scale-105 transition-transform duration-300"></div>
              <img
                src="https://hcamiahiytrjczzsrodb.supabase.co/storage/v1/object/public/etwcministry//ETWC%20Ministry%20Photo%202.avif"
                alt="ETWC Ministry Team"
                className="relative w-full aspect-[4/3] object-cover rounded-2xl shadow-xl transition-all duration-300 group-hover:scale-[1.02] group-hover:shadow-2xl"
              />
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-600 italic">
            "Go therefore and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit." - Matthew 28:19
          </p>
        </div>
      </div>
    </div>
  );
}